import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BaseSharedModule } from 'base';
import { RouterLink } from '@angular/router';
import { BaseCustomerOnboardingService } from './_services/onboarding.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseCustomerOnboardingLightComponent } from './_components/onboarding-light/onboarding-light.component';
import { BaseCustomerOnboardingLightBannerComponent } from './_components/onboarding-light-banner/onboarding-light-banner.component';

@NgModule({
  declarations: [BaseCustomerOnboardingLightComponent, BaseCustomerOnboardingLightBannerComponent],
  imports: [CommonModule, TranslateModule, BaseSharedModule, RouterLink, NgOptimizedImage],
  providers: [BaseCustomerOnboardingService, NgbActiveModal],
  exports: [BaseCustomerOnboardingLightComponent, BaseCustomerOnboardingLightBannerComponent],
})
export class BaseCustomerOnboardingModule {}
